import React, { memo } from "react";
import type { NotesTableContext as NotesTableContextType } from "./types";
import { NotesTableContextProvider } from "./service/NotesTableContextProvider";

export const NotesTable: React.FC<NotesTableContextType["props"]> = memo((props) => {
  return <NotesTableContextProvider noteTableProps={props}></NotesTableContextProvider>;
});
